import type { UpdateMeterDetails } from '@enmon/commons/lib/enmon/meters';

type KeysOfUnion<T> = T extends T ? keyof T : never;
type CommonsMeterDetailKey = Extract<KeysOfUnion<NonNullable<UpdateMeterDetails['detail']>>, string>;

const SUBMIT_ONLY_DETAIL_KEYS = [
  'flowrate.unit',
  'flowrate.value',
  'width.unit',
  'width.value',
  'internalSupplyPointCode',
  'lorawanRssi',
  'nbiotRssi',
  'ownerType',
  'requiresManualAks',
  'submittedBy',
] as const;

const BOOLEAN_DETAIL_KEYS = [
  'isDirect',
  'flange',
  'hotWater',
  'woltman',
] as const satisfies readonly CommonsMeterDetailKey[];

const CURRENT_DETAIL_KEYS = ['iMax', 'iMin', 'iRef'] as const satisfies readonly CommonsMeterDetailKey[];

const SUBMIT_NUMERIC_DETAIL_KEYS = [
  'layLength',
  'pMax',
  'phases',
  'qMax',
  'qMin',
  'tariffs',
] as const satisfies readonly CommonsMeterDetailKey[];

export function isSubmitOnlyDetailKey(key: string) {
  return isDetailKeyIn(SUBMIT_ONLY_DETAIL_KEYS, key);
}

export function isBooleanDetailKey(key: string) {
  return isDetailKeyIn(BOOLEAN_DETAIL_KEYS, key);
}

export function isCurrentDetailKey(key: string) {
  return isDetailKeyIn(CURRENT_DETAIL_KEYS, key);
}

export function isNumericDetailKey(key: string) {
  return isDetailKeyIn(SUBMIT_NUMERIC_DETAIL_KEYS, key);
}

function isDetailKeyIn(values: readonly string[], key: string) {
  return values.some(value => value === key);
}
